// import DataSoap from "@/services/DataSoap";
import { DetailRujukan, DetailSoap, Faskes, Rujukan } from "@/types";
// import UserLogin from "@/utility/User";
import { storeSoap } from "./soap";
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import DataRujukan from "@/services/DataRujukan";

export interface RujukanState {
  rujukan: Rujukan[];
  detailrujukan: DetailRujukan;
  faskes: Faskes[];
  soap: DetailSoap;
}

@Module({ store, dynamic: true, name: "storeRujukan" })
class RujukanStore extends VuexModule implements RujukanState {
  rujukan: Rujukan[] = [];
  detailrujukan: DetailRujukan = null;
  detailrujukanid = {} as DetailRujukan;
  faskes: Faskes[] = [];
  soap = {} as DetailSoap;
  showInput = false;

  @Mutation RESET_ALL() {
    this.rujukan = [];
    this.detailrujukan = null;
    this.detailrujukanid = null;
    this.soap = null;
    this.showInput = false;
  }

  @Mutation SET_RUJUKAN(rujukan: Rujukan[]) {
    this.rujukan = rujukan;
  }
  @Mutation SET_DETAIL_RUJUKAN(detailrujukan: DetailRujukan) {
    this.detailrujukan = detailrujukan;
  }
  @Mutation SET_DETAIL_RUJUKAN_ID(detailrujukanid: DetailRujukan) {
    this.detailrujukanid = detailrujukanid;
  }

  @Mutation SET_SHOW_INPUT(val: boolean) {
    this.showInput = val;
  }

  @Action openInput(): void {
    this.SET_SHOW_INPUT(true);
  }

  @Action closeInput(): void {
    this.SET_SHOW_INPUT(false);
  }

  @Action act_rujukan_on_reg(reg: string) {
    const dt = DataRujukan.getDataRujukanReg(reg);
    dt.then(dt => {
      const rujukan = dt;
      const detailrujukan = dt.data;
      const status = dt.status;
      // console.log('reg')
      this.SET_RUJUKAN(rujukan);
      this.SET_DETAIL_RUJUKAN(detailrujukan);
    });

    return dt;
  }

  @Action act_rujukan_on_reg_new(reg: string) {
    const dt = DataRujukan.getDataRujukanReg(reg);
    dt.then(dt => {
      const detailrujukan = {} as DetailRujukan;
      detailrujukan.tujuan = {} as Faskes;
      detailrujukan.diagnosis = storeSoap.detailSoap[0].a;

      // rujukan.diagnosis = storeSoap.detailSoap[0].a;
      // rujukan.tujuan = {} as Faskes;
      // console.log(dt)
      // this.SET_RUJUKAN(rujukan);
      this.SET_DETAIL_RUJUKAN(detailrujukan);
    });
  }
  // @Action sendModal(): void {
  //   // this.showModal(true);
  // }

  // @Action closeModal(): void {
  //   // this.showModal(false);
  // }
  @Action act_rujukan_on_id(id: number) {
    const dt = DataRujukan.getDataRujukanId(id);
    dt.then(dt => {
      const rujukan = dt;
      const detailrujukan = dt.data;
      const status = dt.status;
      this.SET_DETAIL_RUJUKAN_ID(detailrujukan);
    });
  }

  // @Action act_on_id_new(id: number) {
  //   console.log("ada", id);
  //   if (id == null) {
  //     const detailrujukan = {} as DetailRujukan;
  //     detailrujukan.tujuan = {} as Faskes;
  //     detailrujukan.diagnosis = storeSoap.detailSoap[0].a;
  //     this.SET_DETAIL_RUJUKAN_ID(detailrujukan);
  //   } else {
  //     const dt = DataRujukan.getDataRujukanId(id);
  //     dt.then(dt => {
  //       //   if (dt != undefined) {
  //       const rujukan = dt;
  //       const detailrujukan = dt.data;
  //       const status = dt.status;
  //       // this.SET_RUJUKAN(rujukan);
  //       this.SET_DETAIL_RUJUKAN_ID(detailrujukan);
  //     });
  //   }
  // }

  @Action act_save(detailrujukan: DetailRujukan) {
    // console.log("act ", detailrujukan);
    // const dt = DataRujukan.editDataRujukan(detailrujukan)
    // dt.then(dt => {
    //     // const rujukan = dt
    //     // const status = dt.status
    // this.SET_RUJUKAN(rujukan);
    // });
  }

  @Action act_update(detailrujukan: DetailRujukan) {
    // console.log("act ", detailrujukan);
    // const dt = DataRujukan.saveDataRujukan(detailrujukan);
    // dt.then(dt => {
    //     // const rujukan = dt
    //     // const status = dt.status
    // this.SET_DETAIL_RUJUKAN(detailrujukan);
    // });
  }

  @Action reset() {
    this.RESET_ALL();
  }
}

export const storeRujukan = getModule(RujukanStore);
